import { useGlobalStore } from '@/stores';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { CustomerAppBar } from '@/modules/external/components/external-navigation.component.tsx';
import Container from '@/components/base/container.component';
import { Box, ThemeProvider } from '@mui/material';
import { theme } from '@/config/theme';
import { AnnouncementsHost } from '@components/announcements/announcements-host.component.tsx';

export function ExternalLayout() {
  const { contactEmployeeId, businessPartnerId } = useGlobalStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!businessPartnerId || !contactEmployeeId) {
      navigate('/');
    }
  }, [businessPartnerId, contactEmployeeId]);

  return (
    <ThemeProvider theme={theme}>
      <CustomerAppBar />
      <Container maxWidth={'xl'} sx={{ px: { xs: 1, sm: 2.5 }, pt: 1.5 }}>
        <AnnouncementsHost placement="EXTERNAL_PORTAL" />
      </Container>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <Box
          sx={{
            py: {
              xs: 1.5,
              sm: 2.5,
            },
            flexGrow: 1,
            maxWidth: '100%',
          }}
        >
          <Container
            maxWidth={'xl'}
            className={'flex'}
            sx={{
              px: {
                xs: 1,
                sm: 2.5,
              },
            }}
          >
            <Outlet />
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
}
